export type SupportWidgetMode = "intercom" | "showme" | "none";

export const getSupportWidgetMode = (): SupportWidgetMode => {
  const val = process.env.REACT_APP_SUPPORT_WIDGET?.trim().toLowerCase();
  if (val === "intercom" || val === "showme") return val;
  return "none";
};
